import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c7bcd97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-text-[#878787] tw-text-[10px] title-block" }
const _hoisted_2 = { class: "notification-box tw-mt-[15px]" }

import notificationItem from "./notificationItem.vue";
import { getComponentUiText } from "../../utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'notificationBlock',
  props: {
  data: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  index: {
    type: [Number, String],
    required: true,
  },
  sortAsc: {
    type: Boolean,
    required: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.data.length > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`${__props.index !== 0 ? 'tw-mt-[30px]' : ''} ${
      __props.index === 2 ? 'tw-mb-[40px]' : ''
    }`)
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(getComponentUiText)(__props.title)), 1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (notification, idxItem) => {
            return (_openBlock(), _createElementBlock("div", { key: idxItem }, [
              _createVNode(notificationItem, {
                index: idxItem,
                notification: notification
              }, null, 8, ["index", "notification"])
            ]))
          }), 128))
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})